'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiRefreshOutline = function TiRefreshOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.9 8.3c-0.8 0-2 0.3-3.2 1.3-1.7-0.8-3.7-1.3-5.7-1.3-7.4 0-13.3 6-13.3 13.4s5.9 13.3 13.3 13.3c7.2 0 13.3-5.5 13.3-13.3v-8.3c0-3.5-2.3-5.1-4.4-5.1z m1.1 13.4h-8.5c-1.9 0-2.4-1-1.1-2.3l2.5-2.3c-1-0.7-2.1-1-3.2-1-1.6 0-3 0.7-4.1 1.8-1.1 1.1-1.7 2.5-1.7 4.1 0 1.5 0.6 3 1.7 4.1 1.1 1.1 2.5 1.7 4.1 1.7s3-0.6 4.1-1.7c0.3-0.3 0.5-0.6 0.8-1 0.3-0.5 1-0.9 1.6-0.9 0.4 0 0.7 0.1 1 0.4 0.9 0.5 1.2 1.7 0.6 2.6-0.3 0.6-0.8 1.1-1.3 1.6-1.8 1.9-4.2 2.9-6.8 2.9s-5-1-6.9-2.9c-1.8-1.8-2.8-4.2-2.8-6.8s1-5 2.8-6.8c1.9-1.9 4.3-2.9 6.9-2.9 2.2 0 4.2 0.7 5.9 2.1l1.9-2c0.6-0.5 1.1-0.7 1.4-0.7 0.7 0 1.1 0.6 1.1 1.7v8.3z m-11.8 0.1c0.3 0.6 1.1 1.5 3.3 1.5h2.1s-0.3 0.9-1 1.5-1.8 1.3-2.9 1.3-2.2-0.4-3-1.2c-0.7-0.8-1.2-1.8-1.2-2.9s0.5-1.9 1.2-2.7c0.8-0.8 1.9-1 3-1 0 0-0.4 0.2-0.4 0.2-1.6 1.6-1.4 2.6-1.1 3.2z' })
        )
    );
};

exports.default = TiRefreshOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/refresh-outline.js
// module id = 2159
// module chunks = 0